import { Component, Input } from '@angular/core';

@Component({
    selector: 'black-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent {
  @Input() section = 1;

  @Input()
  steps = ['Basic', 'Contents', 'Preview & Submit'];
}
